import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";

import { setAlert } from "../../../actions/alertActions";

import "../../../styles/components/evs/modals/RequestNetworkAccess.scss";

class ActivateCard extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  handleOnSubmit() {
    const patch = {
      cardNumber: this.props.selectedContract
        ? this.props.selectedContract.cardNumber
        : this.props.selectedEV.contract.cardNumber,
      nif: this.props.selectedContract
        ? this.props.selectedContract.nif
        : this.props.selectedEV.contract.nif,
      email: this.props.selectedContract
        ? this.props.selectedContract.email
        : this.props.selectedEV.contract.email,
    };

    axios
      .patch("/api/private/contracts/validateCard", patch)
      .then((res) => {
        if (res.status === 200) {
          this.props.onHide();
          this.props.setAlert(
            I18n.t("backOffice_physical_card_activate_success_alert"),
            "primary"
          );
          this.props.fetchFleets();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.code)
          this.props.setAlert(I18n.t(err.response.data.message), "danger");
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  }

  render() {
    return (
      <Modal
        id="activateCard"
        show={this.props.show}
        onHide={this.props.onHide}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate value="backOffice_network_client_id" />
          </Modal.Title>
        </Modal.Header>
        <div className="evio-card-container">
          <div
            className="evio-card"
            style={{
              ...(this.props.brand &&
                this.props.brand.brandName !== "EVIO" && {
                  backgroundImage: `url('${
                    this.props.brand.icons?.cards?.big ?? ""
                  }')`,
                }),
            }}
          >
            {this.props.selectedContract && (
              <span>
                <p>{this.props.selectedContract.name}</p>
                <p>{this.props.selectedContract.cardName}</p>
              </span>
            )}

            {this.props.selectedEV && (
              <span>
                <p>{this.props.selectedEV?.contract?.name}</p>
                <p>{this.props.selectedEV?.contract?.cardName}</p>
              </span>
            )}
          </div>
        </div>

        <Modal.Body>
          <div id="join">
            <p className="activate-card-question">
              <Translate value="activate_card_question" />
            </p>
            <div className="item bottom activate-card-btns">
              <button
                type="button"
                className="btn-activate-card"
                onClick={() => this.props.onHide()}
              >
                <Translate value="cancel_btn" />
              </button>
              <button
                type="submit"
                className="btn-activate-card"
                onClick={() => this.handleOnSubmit()}
              >
                <Translate value="activate_card_btn" />
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  country: state.account.accountData.country,
});

export default connect(mapStateToProps, { setAlert })(ActivateCard);
